import t from './story11.translations'

export default {
  title: t.title,
  excerpt: t.excerpt,

  prose: [
    // Run 1 — the open, no heading.
    [{ text: t.s1P1 }, { text: t.s1P2 }, { text: t.s1P3 }],
    // Run 2 — continues after the tunnel figure: Jonathan, then the ore's route
    // from the pit to a touchscreen.
    [{ text: t.s2P1 }, { text: t.s2P2 }, { text: t.s2P3 }, { text: t.s2P4 }],
    // Run 3 — first themed section.
    [{ title: t.s3Title, text: t.s3P1 }, { text: t.s3P2 }, { text: t.s3P3 }],
    // Run 4 — second themed section, after the anonymous miner's pull quote.
    [{ title: t.s4Title, text: t.s4P1 }, { text: t.s4P2 }],
    // Run 5 — continues after the Cerro Rico figure: the right of reply.
    [{ text: t.s5P1 }, { text: t.s5P2 }],
    // Run 6 — third themed section.
    [{ title: t.s6Title, text: t.s6P1 }, { text: t.s6P2 }],
    // Run 7 — continues after the Rivera pull quote.
    [{ text: t.s7P1 }, { text: t.s7P2 }],
    // Run 8 — fourth themed section.
    [
      { title: t.s8Title, text: t.s8P1 },
      { text: t.s8P2 },
      { text: t.s8P3 },
      { text: t.s8P4 },
      { text: t.s8P5 },
    ],
    // Run 9 — fifth themed section.
    [
      { title: t.s9Title, text: t.s9P1 },
      { text: t.s9P2 },
      { text: t.s9P3 },
      { text: t.s9P4 },
    ],
    // Run 10 — the close, after the father-and-son figure.
    [
      { text: t.s10P1 },
      { text: t.s10P2 },
      { text: t.s10P3 },
      { text: t.s10P4 },
      { text: t.s10P5 },
    ],
  ],

  captions: [
    [t.f1P1], // 01 — hero, a young miner and El Tio.
    [t.f2P1], // 02 — a child hauling rocks out of a tunnel.
    [t.f3P1], // 03 — a young miner leaving on his motorbike.
    [t.f4P1], // 04 — breaking rocks in Cerro Rico.
    [t.f5P1], // 05 — father and son preparing dynamite.
    [t.f6P1], // 06 — a young miner and his partner.
    [t.f7P1], // 07 — father and son on a break underground.
  ],

  quotes: [
    { text: t.q1, attribution: t.q1Attr },
    { text: t.q2, attribution: t.q2Attr },
  ],
} as const
